import React from 'react';
import { connect } from 'react-redux';
import { withRouter , Link } from 'react-router';
import * as UserActions from '../../../actions/user_actions';
import { bindActionCreators } from 'redux';
import Header from '../../../components/header';
let screenIdentifier = 'PatienSuerveyResponse';
import _ from 'lodash';
import { validate } from '../../../validations';


export var PatientsSurveyResponse = React.createClass({
    getInitialState() {
        return {

        }
    },
    componentWillMount() {


    },
    componentWillReceiveProps(nextProps) {


    },
    componentDidMount() {

    },

    render() {
        let responsedate = validate.getUrlParam("date");
        
        let recentResponseDate = (this.props.PatientSurvey && this.props.PatientSurvey.data && this.props.PatientSurvey.data.createdDate) ? this.props.PatientSurvey.data.createdDate : 0;
        recentResponseDate = new Date(recentResponseDate);
        let formatedRecentResponseDate = recentResponseDate.getFullYear().toString() + '-' + (recentResponseDate.getMonth() + 1).toString() + '-' + recentResponseDate.getDate().toString();
        return (

            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier}  breadcrumb={true}/>
                <div className="breadcrumb-custom">
                  <h2 title={responsedate ?'SURVEY RESPONSE ON '+ responsedate :'MOST RECENT RESPONSE ON ' + formatedRecentResponseDate }> <Link to="/patients">PATIENTS</Link> > <a onClick={this.props.router.goBack} >{this.props.FacilitiesDetails.FaciliteAdminUser.data.firstName}</a> >{responsedate ?'SURVEY RESPONSE ON '+ responsedate :'MOST RECENT RESPONSE ON ' + formatedRecentResponseDate }</h2>
                </div>
                <div className="admin-details white-box">
                    {_.map(this.props.PatientSurvey && this.props.PatientSurvey.data && this.props.PatientSurvey.data.answers, (v, i) => {

                        var userSelectedAnswer = _.map(v.answers, (v1, i) => {
                            return v1.answer.id;

                        })

                        return <div className="daily-questions" key={i}>
                            {
                                <div>
                                    <p className="daily-paragraph">{v.question.name}</p>
                                    {((v.question.answerType.id === 1) || (v.question.answerType.id === 2) || (v.question.answerType.id === 4) || (v.question.answerType.id === 5)) &&
                                         <div className="medication">
                                            <button className="white-button">{v.shortAnswer}</button>
                                        </div>
                                    }
                                    {(v.question.answerType.id) === 3 &&
                                        _.map(v.question.answer, (followAns, i) => {
                                            return <div key={i}>
                                                    <button className={userSelectedAnswer.indexOf(followAns.id) === -1 ? "white-button" : "white-button active"}>{followAns.name}</button>
                                            </div>
                                        })}
                                    {(v.question.answerType.id) === 6 &&
                                        _.map(v.question.answer, (followAns, i) => {

                                            return <div key={i}>
                                                <div className="medication">
                                                    <button className={userSelectedAnswer.toString() === followAns.id.toString() ? "white-button active " : "white-button"}>{followAns.name}</button>
                                                </div>

                                            </div>
                                        })}
                                    {v.question.answerType.id === 7 &&
                                        _.map(v.question.sliderConfiguration, (followAns, i) => {
                                            let shortAns = Number(v.shortAnswer); // Default UNIQUE
                                            if(v.question.type === 'DAILY' || (v.parent && v.parent.type === 'DAILY')){
                                                if(shortAns === 1 || shortAns === 2 || shortAns === 3){
                                                    shortAns = 1;
                                                }
                                                if(shortAns === 4 || shortAns === 5){
                                                    shortAns = 4;
                                                }
                                                if(shortAns === 6 || shortAns === 7){
                                                    shortAns = 7;
                                                }
                                            }
                                            if(v.question.type === 'WEEKLY' || (v.parent && v.parent.type === 'WEEKLY')){
                                                if(shortAns === 1 || shortAns === 2 ){
                                                    shortAns = 1;
                                                }
                                                if(shortAns === 3){
                                                    shortAns = 3;
                                                }
                                                if(shortAns === 4 || shortAns === 5){
                                                    shortAns = 5;
                                                }
                                            }                                                                                     
                                            return <div key={i}>

                                                    {followAns.data >= 0 &&
                                                        <div className="medication">
                                                        <button className={shortAns === followAns.data ? "white-button active " : "white-button"}>{followAns.value}</button>
                                                            {/* <button className="white-button">very Good</button> */}
                                                            {/* {<button className="white-button">showslider</button>} */}          
                                                        </div>
                                                    }




                                            </div>
                                        })}



                                </div>
                            }
                        </div>
                    })
                    }
                    <h3 className="text-center">{this.props.PatientSurvey && this.props.PatientSurvey.status ===404 && "No response for the current patient."}</h3>
                </div>



            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        PatientSurvey: state.User.patentSuervyResponseData,
        FacilitiesDetails: state.Facilites,
    };
};

let mapDispatchToProps = (dispatch) => ({

    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(PatientsSurveyResponse));


//  <div className="button pull-right all-days"> <button className="icon-box">ALL DAYS</button>  </div>



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/answerdSurvey.js
 **/